// extracted by mini-css-extract-plugin
module.exports = {"card":"ohs6G","link":"zEWaF"};